/**
 * Limit a string to 'limit' characters
 *
 * @param {string} value
 * @param {number} limit
 * @param {string} end
 * @returns {string}
 */
export function strLimit(value, limit = 50, end = '...') {
  return value.length > limit
    ? value.substr(0, limit - 1) + end
    : value;
}

/**
 * @param {*} value
 * @return {boolean}
 */
export function isParsableNumber(value) {
  if (_.isNumber(value)) {
    return true;
  }

  return _.isString(value) && value !== '' && !isNaN(value);
}

/**
 * @param {number} value
 * @return {string}
 */
export function formatMemory(value) {
  if (value >= 1024 * 1024 * 1024) {
    return `${_.round(value / 1024 / 1024 / 1024, 1)} GiB`;
  }

  if (value >= 1024 * 1024) {
    return `${_.round(value / 1024 / 1024, 1)} MiB`;
  }

  if (value >= 1024) {
    return `${_.round(value / 1024, 1)} KiB`;
  }

  return `${value} B`;
}

/**
 * @param {*} value
 * @return {boolean}
 */
export function isBlank(value) {
  if (_.isNil(value)) {
    return true;
  }

  if (_.isString(value)) {
    return _.trim(value) === '';
  }

  if (_.isNumber(value) || _.isBoolean(value)) {
    return false;
  }

  if (_.isArray(value) || _.isObject(value)) {
    return _.isEmpty(value);
  }

  return Boolean(value);
}

/**
 * @param {*} value
 * @return {boolean}
 */
export function isFilled(value) {
  return !isBlank(value);
}

/**
 * @param {*} value
 * @param {function} callback
 * @param {*} defaultValue
 * @return {*}
 */
export function transform(value, callback, defaultValue = null) {
    return isFilled(value) ? callback(value) : defaultValue;
}

/**
 * @param {*} target
 * @param {*} key
 * @param {function} callback
 * @param {*} defaultValue
 * @return {*}
 */
export function getTransformed(target, key, callback, defaultValue = null) {
    return transform(
        _.get(target, key, null),
        callback,
        defaultValue
    );
}
